module.exports = __webpack_public_path__ + "assets/images/rideCleanup-8455cbba1596ab7765d8aea31c76f256.mp4";